<template>
    <div>
        <el-dialog
            :title='mallHotelStates[mallHotelState]'
            :visible='showDialog'
            width='80%'
            @close='closeDialog'
        >
            <el-form
                :model='mallHotel'
                ref='mallHotelForm'
                :rules='rules'
                label-width='120px'
                :inline='true'
                size='small'
            >
                <el-tabs type='border-card'>
                    <el-tab-pane label='基本信息'>
                        <el-form-item
                            label='酒店名称'
                            prop='hotelName'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.hotelName'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label='酒店品牌' prop='brandId'>
                            <GridSelect
                                style='width: 200px'
                                title='选择品牌'
                                labelName='brandName'
                                labelValue='id'
                                :stateDisabled="mallHotelState == 'check'"
                                :value='mallHotel.brandId'
                                :limit='1'
                                size='small'
                                placeholder='请选择品牌'
                                @getValue='getValue'
                                :columns="BRAND_code"
                                :searchs="BRAND_search"
                                dataListUrl='/mall/hotelbrand/findList'
                                entityBeanName='mallHotelBrand'
                                queryEntityUrl='/mall/hotelbrand/get'
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item label='酒店位置' prop='hotelAddress'>
                            <!-- <location
                                style='width: 200px;'
                                :areaTreeDate='areaTreeDate'
                                :mallHotel='mallHotel'
                                :disabled="mallHotelState == 'check'"
                                @location='getlocation'
                            ></location> -->
                            <location
                                style='width: 200px;'
                                :areaTreeDate="areaTreeDate"
                                :longitude="mallHotel.hotelPosition.split(',')[0]"
                                :latitude="mallHotel.hotelPosition.split(',')[1]"
                                :provinceId="mallHotel.provinceId"
                                :cityId="mallHotel.cityId"
                                :areaId="mallHotel.areaId"
                                :address="mallHotel.hotelAddress"
                                :disabled="mallHotelState == 'check'"
                                @getLocation="getlocation"
                            ></location>
                        </el-form-item>
                        <el-form-item
                            label='酒店坐标'
                            prop='hotelPosition'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.hotelPosition'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='经度'
                            prop='longitude'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.longitude'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='纬度'
                            prop='latitude'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.latitude'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label='省' prop='provinceId'>
                            <el-select
                                placeholder='请选择省'
                                @change="clearSubitem('province')"
                                clearable
                                style='width: 200px'
                                size='small'
                                :disabled="mallHotelState == 'check'"
                                v-model='mallHotel.provinceId'
                            >
                                <el-option
                                    v-for='(item,index) in provinceArry'
                                    :key='index'
                                    :label='item.areaName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='市' prop='cityId'>
                            <el-select
                                placeholder='请选择市'
                                @change="clearSubitem('city')"
                                clearable
                                style='width: 200px'
                                size='small'
                                :disabled="mallHotelState == 'check'"
                                v-model='mallHotel.cityId'
                            >
                                <el-option
                                    v-for='(item,index) in cityArry'
                                    :key='index'
                                    :label='item.areaName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='区' prop='areaId'>
                            <el-select
                                placeholder='请选择区'
                                clearable
                                style='width: 200px'
                                size='small'
                                :disabled="mallHotelState == 'check'"
                                v-model='mallHotel.areaId'
                            >
                                <el-option
                                    v-for='(item,index) in areaArry'
                                    :key='index'
                                    :label='item.areaName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label='酒店标签' prop='hotelTag'>
                            <tag
                                style='width: 200px'
                                :value='mallHotel.hotelTag'
                                :disabled="mallHotelState == 'check'"
                                @getTagValue='getTagValue'
                            ></tag>
                        </el-form-item>
                        <el-form-item
                            label='综合评分'
                            prop='starNumber'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.starNumber'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='总评论数'
                            prop='commentNumber'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.commentNumber'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='是否精选'
                            prop='isSelected'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.isSelected'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='联系人'
                            prop='contactPerson'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.contactPerson'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='联系电话'
                            prop='contactPhone'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.contactPhone'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='店铺管理'
                            prop='userId'
                        >
                            <GridSelectU
                                style='width: 200px'
                                title='选择用户'
                                labelName='userName'
                                labelValue='id'
                                :disabled="mallHotelState == 'check'"
                                :value='mallHotel.userId'
                                :limit='1'
                                size='small'
                                placeholder='请选择用户'
                                @getValue='getValueUser'
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                queryEntityUrl='/mpp/user/get'
                            >
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item label='最晚退订时间' prop='canCancelTime'>
                            <el-time-picker
                                style='width: 200px'
                                size='small'
                                format='HH:mm:ss'
                                value-format='HH:mm:ss'
                                v-model='mallHotel.canCancelTime'
                                :disabled="mallHotelState == 'check'"
                                placeholder='请选择可取消时间'>
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item label='离店时间' prop='checkoutTime'>
                            <el-time-picker
                                style='width: 200px'
                                size='small'
                                format='HH:mm:ss'
                                value-format='HH:mm:ss'
                                v-model='mallHotel.checkoutTime'
                                :disabled="mallHotelState == 'check'"
                                placeholder='请选择离店时间'>
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item
                            label='最低价格'
                            prop='minPrice'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.minPrice'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='最高价格'
                            prop='maxPrice'
                        >
                            <el-input
                                size='small'
                                style='width: 200px'
                                v-model='mallHotel.maxPrice'
                                :disabled="mallHotelState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='酒店logo'
                            prop='hotelLogo'
                            class='logo'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadAvatar'
                                :disabled="mallHotelState == 'check'"
                            >
                                <img v-if='mallHotel.hotelLogo' :src='mallHotel.hotelLogo' class='avatar'
                                     size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label='酒店图片'>
                        <el-form-item
                            prop='productAlbum'
                        >
                            <el-upload
                                :headers='header'
                                class='uploadAlbum'
                                :action='action'
                                :on-remove='handleRemove'
                                :file-list='fileList'
                                :on-success='handleSuccess'
                                :before-upload='beforeAvatarUpload'
                                :disabled="mallHotelState == 'check'"
                                list-type='picture'
                                accept='jpg,jpeg,png,JPG,JPEG,PNG'
                                :limit='10'
                            >
                                <el-button size='small' type='primary'>点击上传</el-button>
                                <div slot='tip' class='el-upload__tip'>
                                    只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB
                                </div>
                            </el-upload>
                        </el-form-item>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <div
                slot='footer'
                class='flex justify-end'
            >
                <el-button @click='closeDialog'>关闭</el-button>
                <el-button
                    type='primary'
                    @click='submitForm'
                    v-if="mallHotelState != 'check'"
                >确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Tag from '@/components/tag/tag.vue';
import Location from '@/components/location/location.vue';
import { post, upload } from '@/utils/request';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH, BRAND, BRAND_SEARCH } from '@/utils/constant';
import GridSelect from '@/components/gridselect/brand.vue';
import GridSelectU from '@/components/gridselect/index.vue';

export default {
    components: {
        GridSelectU,
        GridSelect,
        Location,
        Tag
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        mallHotel: {
            type: Object,
            default: {}
        },
        mallHotelState: {
            type: String,
            default: 'add'
        },
        areaTreeDate: {
            type: Array,
            default: []
        }
    },
    watch: {
        mallHotel(value) {
            console.log(value);
            if (value) {
                console.log('11111111111222');
                this.fileList = this.mallHotel.hotelBanner.split('|').map((item) => {
                    return {
                        name: item,
                        url: item
                    };
                });
                this.temporaryList = [];
                for (let item of this.fileList) {
                    this.temporaryList.push(item);
                }
                this.albumList = '';
                this.albumList = this.temporaryList.join('|');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            BRAND_code: BRAND,
            BRAND_search: BRAND_SEARCH,
            temporaryList: [],
            fileList: [],
            action: UPLOAD_API + UPLOAD_PATH,
            header: {
                token: localStorage.getItem('token')
            },
            mallHotelStates: {
                add: '新建酒店',
                check: '查看酒店',
                edit: '修改酒店'
            },
            rules: {
                hotelName: [{ required: true, message: '酒店名称不能为空', trigger: 'blur' }],
                hotelLogo: [{ required: true, message: '酒店logo不能为空', trigger: 'blur' }],
                hotelBanner: [{ required: true, message: '酒店banner不能为空', trigger: 'blur' }],
                brandId: [{ required: true, message: '品牌ID不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                hotelAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                hotelPosition: [{ required: true, message: '定位不能为空', trigger: 'blur' }],
                longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
                latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
                hotelTag: [{ required: true, message: '标签不能为空', trigger: 'blur' }],
                starNumber: [{ required: true, message: '综合评分不能为空', trigger: 'blur' }],
                commentNumber: [{ required: true, message: '总评论数不能为空', trigger: 'blur' }],
                isSelected: [{ required: true, message: '是否精选不能为空', trigger: 'blur' }],
                contactPerson: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                paymentCode: [{ required: true, message: '收款码不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '核审状态不能为空', trigger: 'blur' }],
                refuseReason: [{ required: true, message: '拒绝原因不能为空', trigger: 'blur' }],
                canCancelTime: [{ required: true, message: '可取消时间不能为空', trigger: 'blur' }],
                checkoutTime: [{ required: true, message: '结账时间不能为空', trigger: 'blur' }],
                minPrice: [{ required: true, message: '最低价格不能为空', trigger: 'blur' }],
                maxPrice: [{ required: true, message: '最高价格不能为空', trigger: 'blur' }]
            }
        };
    },
    computed: {
        provinceArry() {
            return this.areaTreeDate;
        },
        cityArry() {
            if(!this.provinceArry){
                return []
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if (this.provinceArry[i].id === this.mallHotel.provinceId) {
                        return this.provinceArry[i].children;
                    } else if (this.mallHotel.provinceId === '') {
                        return [];
                    }
                }
            }
        },
        areaArry() {
            if(!this.cityArry){
                return []
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if (this.cityArry[i].id === this.mallHotel.cityId) {
                        return this.cityArry[i].children;
                    }
                }
            }
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        submitForm() {
            this.$refs.mallHotelForm.validate((valid) => {
                if (valid) {
                    this.$emit('submitForm');
                    this.temporaryList = [];
                    this.fileList = [];
                }
            });
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallHotel.hotelLogo = res.url;
                }
            });
        },
        handleRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (file.response.url === this.temporaryList[i]) {
                    this.temporaryList.splice(i, 1);
                }
            }
            this.mallHotel.hotelBanner = this.temporaryList.join('|');
        },
        handleSuccess(response, file, fileList) {
            this.temporaryList.push(file.response.url);
            this.mallHotel.hotelBanner = this.temporaryList.join('|');
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        getValue(value) {
            this.mallHotel.brandId = value;
        },
        // 省市区清除器
        clearSubitem(id) {
            if (id == 'province') {
                this.mallHotel.cityId = '';
                this.mallHotel.areaId = '';
            } else if (id == 'city') {
                this.mallHotel.areaId = '';
            }
        },
        getlocation(location) {
            this.mallHotel.hotelPosition = `${location.lng},${location.lat}`;
            this.mallHotel.longitude = location.lng;
            this.mallHotel.latitude = location.lat;
            this.mallHotel.hotelAddress = location.address;
            this.mallHotel.provinceId = location.province;
            this.mallHotel.cityId = location.city;
            this.mallHotel.areaId = location.area;
        },
        getTagValue(value) {
            this.mallHotel.hotelTag = value;
        },
        getValueUser(value) {
            this.mallHotel.userId = value;
        }
    }
};
</script>
<style scoped lang='scss'>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.logo {
    ::v-deep .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 200px;
        height: 200px;
    }
}
</style>